// eslint-disable-next-line no-restricted-imports
import type { OrganizationsResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import type { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import type { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
import type {
  LoadTeamQuery,
  LoadTeamQueryVariables,
} from './LoadTeamQuery.generated';
import { LoadTeamDocument } from './LoadTeamQuery.generated';

export const LOAD_TEAM_REQUEST = Symbol('loaders/LOAD_TEAM_REQUEST');
export const LOAD_TEAM_SUCCESS = Symbol('loaders/LOAD_TEAM_SUCCESS');

export type LoadTeamRequestAction = Action<typeof LOAD_TEAM_REQUEST, string>;

export type LoadTeamSuccessAction = Action<
  typeof LOAD_TEAM_SUCCESS,
  OrganizationsResponse
>;

// Action creators
const loadTeamRequest = actionCreator<LoadTeamRequestAction>(LOAD_TEAM_REQUEST);
const loadTeamSuccess = actionCreator<LoadTeamSuccessAction>(LOAD_TEAM_SUCCESS);

export const loadTeam = (teamName: string): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadTeamRequest(teamName));

    const { data, error } = await client.query<
      LoadTeamQuery,
      LoadTeamQueryVariables
    >({
      query: LoadTeamDocument,
      variables: {
        orgId: teamName,
      },
      context: {
        operationName: 'LoadTeam',
        document: LoadTeamDocument,
      },
    });

    const team: OrganizationsResponse = data.organization as OrganizationsResponse;
    if (error || !team) {
      return;
    }

    dispatch(loadTeamSuccess(team));
  };
};
